import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ArticuloProveedorService } from 'app/services/articuloproveedor.service';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { AsociarProductosDialogComponent } from './asociar-productos-dialog.component';

@Component({
  selector: 'app-productos-proveedor-tab',
  templateUrl: './productos-proveedor-tab.component.html',
})
export class ProductosProveedorTabComponent implements OnInit {
  @Input() idProveedor: number;
  productosDataSource = new MatTableDataSource<any>([]);

  constructor(private articuloproveedorService: ArticuloProveedorService, public dialog: MatDialog) {}

  ngOnInit(): void {
    this.cargarProductos();
  }

  cargarProductos() {
    if (!this.idProveedor) return;
    this.articuloproveedorService.getArticulosByProveedor(this.idProveedor).subscribe((res) => {
      this.productosDataSource.data = res || [];
    });
  }

  abrirDialogoProducto() {
    // Obtener IDs de productos ya asociados
    const productosActuales = this.productosDataSource.data || [];
    const idsActuales = productosActuales.map((p: any) => p.article?.id || p.id);
    const dialogRef = this.dialog.open(AsociarProductosDialogComponent, {
      width: '500px',
      data: { idProveedor: this.idProveedor, idsActuales },
    });
    dialogRef.afterClosed().subscribe((seleccionados: any[]) => {
      if (seleccionados && seleccionados.length > 0) {
        if (seleccionados.length === 1) {
          this.articuloproveedorService.addProveedorArticulo(seleccionados[0].id, this.idProveedor).subscribe(() => {
            this.cargarProductos();
          });
        } else {
          const ids = seleccionados.map((p) => p.id);
          this.articuloproveedorService.bulkLinkProveedorArticulos(this.idProveedor, ids).subscribe(() => {
            this.cargarProductos();
          });
        }
      }
    });
  }

  eliminarProducto(producto: any) {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar este producto del proveedor?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.articuloproveedorService.deleteProveedorArticulo(producto?.article?.id , this.idProveedor).subscribe(() => {
          this.cargarProductos();
        });
      }
    });
  }
}
